import { Layout, Image, QRCode } from "antd";
import { useEffect, useMemo, useState } from "react";
import { CheckoutInfoResponse } from "../../../types/CheckoutInfoResponse";
import InfoCard from "../shared/InfoCard";

import banksImg from "../../../assets/bankService.png";
import WrappedCard from "../../antd/WrappedCard";

type QRcordTypeProps = {
  getCheckoutInfoData: CheckoutInfoResponse;
};

const { Content } = Layout;

const IdQrCodeMode = ({ getCheckoutInfoData }: QRcordTypeProps) => {
  const [qrcordUrl, setQrcordUrl] = useState("");
  const amountInfoList = useMemo(() => {
    return [
      {
        label: "Jumlah yang Harus Dibayar",
        value: getCheckoutInfoData?.orderAmount
      }
    ];
  }, [getCheckoutInfoData]);

  useEffect(() => {
    if (getCheckoutInfoData && getCheckoutInfoData.qrcodeUrl) {
      setQrcordUrl(getCheckoutInfoData.qrcodeUrl);
    }
  }, [getCheckoutInfoData]);

  return (
    <Content>
      <InfoCard
        cardTitle="Informasi"
        descTitle="jumlah"
        itemList={amountInfoList}
      />
      <WrappedCard
        cardProps={{
          style: { textAlign: "center" }
        }}
      >
        {qrcordUrl && (
          <QRCode
            value={qrcordUrl}
            bordered={false}
            size={300}
            style={{ margin: "0 auto" }}
          />
        )}
        <Image src={banksImg} preview={false} />
      </WrappedCard>
    </Content>
  );
};

export default IdQrCodeMode;
